if (!customElements.get('valvetronic-sound-player')) {
  customElements.define('valvetronic-sound-player', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const button = this.querySelector('button');
      const template = this.querySelector('template');
      if (!button || !template) return;
      this.initialized = true;
      button.addEventListener('click', () => {
        // Keep other sound demos from playing over the selected clip.
        document.querySelectorAll('valvetronic-sound-player').forEach((player) => {
          if (player !== this) player.reset();
        });
        const media = template.content.firstElementChild.cloneNode(true);
        this.appendChild(media);
        this.setAttribute('data-loaded', '');
        button.hidden = true;
        if (media.tagName === 'VIDEO') {
          this.setAttribute('data-paused', '');
          media.addEventListener('playing', () => this.removeAttribute('data-paused'));
          media.addEventListener('pause', () => {
            if (this.contains(media)) this.setAttribute('data-paused', '');
          });
          media.setAttribute('aria-label', button.getAttribute('aria-label').replace(/^Play /, ''));
          media.setAttribute('tabindex', '0');
          media.addEventListener('ended', () => {
            const restoreFocus = document.activeElement === media;
            this.reset();
            if (restoreFocus) button.focus({ preventScroll: true });
          }, { once: true });
          // Playback follows a user gesture; native controls remain available if blocked.
          media.play().catch(() => {});
        }
        media.focus();
      });
    }

    reset() {
      const media = this.querySelector('iframe, video');
      if (media?.tagName === 'VIDEO') media.pause();
      media?.remove();
      this.removeAttribute('data-loaded');
      this.removeAttribute('data-paused');
      const button = this.querySelector('button');
      if (button) button.hidden = false;
    }
  });
}
